// extracted by mini-css-extract-plugin
export default {"tooltip-wrapper":"configurator-web-tooltip-wrapper"};